import { toRem } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme, isVisible }) => ({
    position: 'fixed',
    top: isVisible ? 0 : -100,
    left: 0,
    right: 0,
    zIndex: 100,
    background: 'linear-gradient(0deg, rgba(0, 27, 40, 0.50), rgba(0, 27, 40, 0.50)), rgba(81, 131, 155, 0.1)',
    backdropFilter: 'blur(200px)',
    transition: 'top 0.5s ease',

    [theme.breakpoints.up('lg')]: {
        top: isVisible ? 100 : -100
    },

    '& .BoatStickyMenuContainer': {
        margin: '0 auto',
        padding: '16px 40px',
        maxWidth: 1360,
        display: 'flex',
        justifyContent: 'space-between',

        [theme.breakpoints.up('md')]: {
            padding: '20px 40px'
        }
    },

    '& .Menu-StickyLeft': {
        display: 'flex',
        alignItems: 'center',

        [theme.breakpoints.up('md')]: {
            alignItems: 'baseline'
        },

        '& .boatTitle': {
            fontSize: toRem(14),
            marginRight: toRem(15),

            [theme.breakpoints.up('md')]: {
                fontSize: toRem(24)
            }
        },
        '& .boatModel': {
            fontSize: toRem(14),
            display: 'none',

            [theme.breakpoints.up('md')]: {
                display: 'block'
            }
        }
    },

    '& .Menu-StickyRight': {
        display: 'flex',
        alignItems: 'baseline',
        '& .boatPrice': {
            marginRight: toRem(40),
            display: 'none',

            [theme.breakpoints.up('md')]: {
                display: 'block'
            }
        }
    }
})

export default style
